import React, { forwardRef, useImperativeHandle, useRef } from 'react'

import Slider from 'react-slick'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'

const SliderComponent = forwardRef((props, ref) => {
  var sliderRef = {}
  var settings = {
    centerMode: true,
    dots: true,
    arrows: true,
    infinite: false,
    speed: 500,
    variableWidth: true,
    dotsClass: 'slick-dots card__slider-dots',
    slidesToShow: 1,
    slidesToScroll: 1,
  }

  useImperativeHandle(ref, () => ({
    GotoSlick() {
      sliderRef.slickGoTo(0)
    },
  }))

  return props.children ? (
    <Slider
      className={'card__slider'}
      ref={slider => (sliderRef = slider)}
      {...settings}
    >
      {props.children.map((obj, index) => {
        return <React.Fragment key={index}>{obj}</React.Fragment>
      })}
    </Slider>
  ) : (
    <></>
  )
})

const GlobalATC = ({ chidrens }) => {
  const childRef = useRef()

  return (
    <SliderComponent className="card__slider" ref={childRef}>
      {chidrens}
    </SliderComponent>
  )
}

export default GlobalATC
